<template>
  <div>
    <wc-data-box hideToolbar>
      <v-simple-table dense>
        <tbody>
          <tr>
            <td>Amount</td>
            <td class='text-right'>
              {{ this.estimate.amount | decMoney }}
            </td>
          </tr>
          <tr>
            <td>Tax</td>
            <td class='text-right'>
              {{ tax | decMoney }}
            </td>
          </tr>
          <tr>
            <td class='py-3 headline font-weight-light'>Total</td>
            <td class='py-3 headline text-right'>
              {{ total | decMoney }}
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </wc-data-box>
  </div>
</template>

<script>
import _ from 'lodash'
import settings from '@/modules/settings/api/settings'

export default {
  name: 'estimate-totals',
  props: {
    estimate: {
      required: true
    }
  },
  data: () => ({
    icon: 'mdi-currency-usd',
    iconColor: 'success',
    settings: {}
  }),
  computed: {
    tax () {
      return _.multiply(this.settings.tax_rate_perc, this.estimate.amount)
    },
    total () {
      return _.add(this.tax, this.estimate.amount)
    }
  },
  created () {
    this.getSettings()
  },
  methods: {
    async getSettings () {
      this.settings = await settings.getSettings()
    }
  }
}
</script>
